import React from 'react'
import { motion } from 'framer-motion'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

const AccountantSettings: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
    >
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Financial Settings</h1>
          <p className="text-gray-600">Configure financial preferences and system settings</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Payment Configuration</CardTitle>
            <CardDescription>Manage payment modes and fee structures</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium">Default Payment Modes</label>
              <div className="space-y-2">
                {['Online', 'Cash', 'Cheque', 'Bank Transfer'].map((mode) => (
                  <div key={mode} className="flex items-center space-x-2">
                    <input type="checkbox" defaultChecked className="rounded" />
                    <span className="text-sm">{mode}</span>
                  </div>
                ))}
              </div>
            </div>
            <Button size="sm">Update Payment Settings</Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Notification Preferences</CardTitle>
            <CardDescription>Configure financial alerts and reminders</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium">Alert Types</label>
              <div className="space-y-2">
                {['Payment Received', 'Overdue Payments', 'Daily Summary', 'Monthly Reports'].map((alert) => (
                  <div key={alert} className="flex items-center space-x-2">
                    <input type="checkbox" defaultChecked className="rounded" />
                    <span className="text-sm">{alert}</span>
                  </div>
                ))}
              </div>
            </div>
            <Button size="sm">Update Notifications</Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Report Preferences</CardTitle>
            <CardDescription>Customize report formats and schedules</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium">Auto-generated Reports</label>
              <div className="space-y-2">
                {['Daily Collections', 'Weekly Summary', 'Monthly Analysis', 'Quarterly Review'].map((report) => (
                  <div key={report} className="flex items-center space-x-2">
                    <input type="checkbox" defaultChecked className="rounded" />
                    <span className="text-sm">{report}</span>
                  </div>
                ))}
              </div>
            </div>
            <Button size="sm">Update Report Settings</Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Security Settings</CardTitle>
            <CardDescription>Financial data access and security preferences</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <label className="text-sm font-medium">Access Controls</label>
              <div className="space-y-2">
                {['Two-Factor Authentication', 'Session Timeout', 'IP Restrictions', 'Audit Logging'].map((security) => (
                  <div key={security} className="flex items-center space-x-2">
                    <input type="checkbox" defaultChecked className="rounded" />
                    <span className="text-sm">{security}</span>
                  </div>
                ))}
              </div>
            </div>
            <Button size="sm">Update Security Settings</Button>
          </CardContent>
        </Card>
      </div>
    </motion.div>
  )
}

export default AccountantSettings
